<template>
  <article class="single-part" ref="rootEl">
    <div class="flex justify-between">
      <small class="code">
        <span>• LIBERATORIA N°</span>{{ el?.id || '---' }}<br />
        <div v-if="el?.user_reward_assignment?.user?.username">
          <span>Premio assegnato il: </span>
          <time v-if="el?.user_reward_assignment?.created_at">
          {{ formatDate(el?.user_reward_assignment?.created_at) }}
        </time>
        </div>
        <div v-if="el?.user_reward_assignment?.user?.username">
          <span>Liberatoria compilata il: </span>
          <time v-if="el?.created_at">
          {{ formatDate(el?.created_at) }}
        </time>
        </div>
      </small>
      <a
        v-if="el?.user_reward_assignment?.user?.dashboard_url"
        :href="el?.user_reward_assignment?.user?.dashboard_url"
        class="font-bold underline hover:no-underline text-primary-orange text-sm">
        Link all'utente in Dashboard
      </a>
      <span class="rejected" v-if="el.rejected">
        Partecipazione respinta
      </span>
      <span class="approved" v-if="el.approved">
        Partecipazione approvata
      </span>
    </div>
    <section class="user">
      <div class="data">
        <div v-if="el?.user_reward_assignment?.user?.username">
          <span>Username:</span>
          {{ el?.user_reward_assignment?.user?.username || '---' }}
        </div>
        <div v-if="el?.first_name">
          <span>Nome:</span>
          {{ el?.first_name || '---' }}
        </div>
        <div v-if="el?.last_name">
          <span>Cognome:</span>
          {{ el?.last_name || '---' }}
        </div>
        <div v-if="el?.city">
          <span>Città:</span>
          {{ el?.city || '---' }}
        </div>
        <div v-if="el?.state">
          <span>Provincia:</span>
          {{ el?.state || '---' }}
        </div>
        <div v-if="el?.street">
          <span>Via:</span>
          {{ el?.street || '---' }}
        </div>
        <div v-if="el?.zip_code">
          <span>CAP:</span>
          {{ el?.zip_code || '---' }}
        </div>
        <div v-if="el?.email_address">
          <span>Email:</span>
          {{ el?.email_address || '---' }}
        </div>
        <div v-if="el?.phone_number">
          <span>Numero di telefono:</span>
          {{ el?.phone_number || '---' }}
        </div>
        <div v-if="el?.user_reward_assignment?.instant_win_time?.prize?.slug">
          <span>Premio:</span>
          {{ el?.user_reward_assignment?.instant_win_time?.prize?.slug || '---' }}
        </div>
        <div v-if="el?.accept_use_for_media">
          <span>Privacy_immagine:</span>
          {{ el?.accept_use_for_media || '---' }}
        </div>
      </div>
      <div class="pics">
        <div class="bg-primary-lgray px-2 py-1 rounded-lg">
          <h6>Documento: <small v-if="el?.doc_type">{{ el?.doc_type }}</small></h6>
          <h6 v-if="el?.doc_number">N° DOCUMENTO: <small>{{ el?.doc_number}}</small></h6>
          <h6 v-if="el?.doc_expiration">SCADENZA DOCUMENTO: <small>{{ formatDate(el?.doc_expiration)}}</small></h6>
        </div>
        <div v-if="img1">
          <small>- FRONTE</small>
          <a :href="img1" target="_blank">⇓ SCARICA FRONTE
          </a>
        </div>
        <div v-if="img2">
          <small>- RETRO</small>
          <a :href="img2" target="_blank">⇓ SCARICA RETRO
          </a>
        </div>
        <div v-if="loadingImgs && hasAnyDocUrl">
          - Caricamento documenti...
        </div>
        <div v-else-if="isVisible && !img1 && !img2">
          - Non pervenuto
        </div>
      </div>
    </section>
    <div class="accepted" v-if="el?.accept_prize === true">
      ✓ PREMIO ACCETTATO
    </div>
    <div class="not-accepted" v-else-if="el?.accept_prize === false">
      ✗ PREMIO RIFIUTATO
    </div>
    <hr />
    <div class="moderation-group" v-if="key === 0 && !el.rejected && !el.approved && img1 && img2">
      <button @click="openAlert(true)" class="moderation ok">
        Approva la liberatoria
      </button>
      <button @click="openAlert(false)" class="moderation not-ok">
        Rifiuta la liberatoria
      </button>
      <span class="confirm" v-if="showAlert">
        <i v-if="confirm === true">Confermi di voler approvare la liberatoria con id #{{ el?.id }}?</i>
        <i v-if="confirm === false">Confermi di voler rifiutare la liberatoria con id #{{ el?.id }}?</i>
        <textarea v-model="notes" placeholder="Motivazione del rifiuto" v-if="confirm === false"
          class="w-full my-2 p-2">
        </textarea>
        <button class="yes" @click="fireModeration">Conferma</button>
        <button class="no" @click="resetAlert">Annulla</button>
      </span>
    </div>
    <div v-else-if="img1 && img2">
      Partecipazione moderata correttamente.
    </div>
    <div v-else-if="updated">
      Dati della partecipazione aggiornati: ricaricare la pagina.
    </div>
    <div class="id" v-if="el?.id">
      #{{ el?.id }}
    </div>
    <!-- <ReleaseOverlay
      :partID="el?.id"
      :userData="userData"
      v-if="overlayOpen && el?.id"
      @closeOverlay="this.overlayOpen = false"
      @refreshStatus="updated = true"
    /> -->
  </article>
</template>

<script>
import moment from 'moment'
moment.locale('it')
// import ReleaseOverlay from '@/components/ReleaseOverlay.vue'
export default {
  props: ['el'],
  // components: {
  //   ReleaseOverlay
  // },
  data () {
    return {
      showAlert: false,
      confirm: null,
      key: 0,
      img1: null,
      img2: null,
      loadingImgs: false,
      imgLoadSeq: 0,
      isVisible: false,
      io: null,
      updated: false,
      overlayOpen: false,
      notes: null
    }
  },
  computed: {
    docFrontUrl () {
      return this.el?.identity_document_urls?.identity_document_front || null
    },
    docBackUrl () {
      return this.el?.identity_document_urls?.identity_document_back || null
    },
    hasAnyDocUrl () {
      return Boolean(this.docFrontUrl || this.docBackUrl)
    },
    userData () {
      const data = {
        terms_accepted: true,
        privacy1_accepted: true
      }
      if (this.el.extra_data.user_code) data.username = this.el.extra_data.user_code
      if (this.el.extra_data.email) data.email = this.el.extra_data.email
      if (this.el.extra_data.phone_number) data.phone_number = this.el.extra_data.phone_number
      if (this.el.item_number) data.played_code = this.el.item_number
      return data
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('lll')
    },
    toggleOverlay () {
      this.overlayOpen = !this.overlayOpen
    },
    async getPartecipationImg (img) {
      if (img) {
        return await this.$store.dispatch('getOuterImage', img)
          .then((response) => {
            return URL.createObjectURL(response.data)
          })
          .catch((e) => {
            console.log('MISSING IMG', e)
          })
      }
    },
    resetIdentityDocs () {
      // Bump seq so any pending async work becomes stale
      this.imgLoadSeq++
      this.loadingImgs = false
      this.img1 = null
      this.img2 = null
    },
    async loadIdentityDocs () {
      const seq = ++this.imgLoadSeq
      if (!this.hasAnyDocUrl) {
        this.loadingImgs = false
        this.img1 = null
        this.img2 = null
        return
      }
      this.loadingImgs = true
      this.img1 = null
      this.img2 = null

      // Load in a deterministic order (front first, then back) so UI updates
      // are less "random" when many cards load concurrently.
      if (this.docFrontUrl) {
        const front = await this.getPartecipationImg(this.docFrontUrl)
        if (seq !== this.imgLoadSeq) return
        this.img1 = front || null
      }

      if (this.docBackUrl) {
        const back = await this.getPartecipationImg(this.docBackUrl)
        if (seq !== this.imgLoadSeq) return
        this.img2 = back || null
      }

      if (seq !== this.imgLoadSeq) return
      this.loadingImgs = false
    },
    setupVisibilityObserver () {
      // Lazy-load identity docs only when the card is near the viewport.
      // This reduces backend calls and speeds up initial render.
      if (this.isVisible) return
      const el = this.$refs.rootEl
      if (!el) return

      if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          const hit = entries && entries.some(e => e.isIntersecting)
          if (!hit) return
          this.isVisible = true
          this.loadIdentityDocs()
          if (this.io) this.io.disconnect()
          this.io = null
        }, {
          root: null,
          rootMargin: '200px 0px', // preload a bit before it becomes visible
          threshold: 0.01
        })
        this.io.observe(el)
      } else {
        // Fallback: load immediately (older browsers / non-DOM env)
        this.isVisible = true
        this.loadIdentityDocs()
      }
    },
    async fireModeration () {
      const payload = {
        id: this.el.id,
        pay: {
          approved: null,
          rejected: null
        }
      }
      if (this.confirm === true) {
        payload.pay.approved = true
        payload.pay.rejected = false
      }
      if (this.confirm === false) {
        payload.pay.rejected = true
        payload.pay.approved = false
        if (this.notes) payload.pay.notes = this.notes
      }
      await this.$store.dispatch('updateRelease', payload)
        .then((rsp) => {
          if (rsp) {
            this.key++
            console.log('RSP', rsp)
          } else {
            const error = true
            const msg = 'ERRORE durante la conferma: ripetere la procedura.'
            this.emitter.emit('fireAlert', { msg, error })
          }
        })
    },
    resetAlert () {
      this.showAlert = false
      this.confirm = null
    },
    openAlert (bool) {
      this.showAlert = true
      this.confirm = bool
    }
    // getReleaseField (el, field) {
    //   let release = null
    //   if (el) release = el.tokens[0].played_token.partecipation.release
    //   if (field && release) return release[field]
    //   return release
    // }
  },
  watch: {
    'el.id': {
      immediate: true,
      handler () {
        this.resetIdentityDocs()
        if (this.isVisible) this.loadIdentityDocs()
      }
    }
  },
  mounted () {
    this.setupVisibilityObserver()
  },
  beforeUnmount () {
    if (this.io) this.io.disconnect()
    this.io = null
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/components/partecipation.scss";
</style>
